import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ReminderCheckbox } from './dynamic/ReminderCheckbox.jsx';
import { OtherCheckbox } from './dynamic/OtherCheckbox.jsx';
import { ErrorMessage } from '../shared/ErrorMessage.jsx';
import I18n from 'i18n-js';
import '../translations.js';
export class SmsReminderEdit extends Component {
  render () {
    return (
      <div className="container">
        { this.props.error ?
          <ErrorMessage message={this.props.error}/> :
          undefined
        }
        <div className="form-group row">
          <div className="col-xs-1">
            <input type="number" className="form-control input-sm" onChange={this.props.timeInput} value={this.props.minutes}/>
          </div>
            {I18n.t("exhibitor.gate_time_reminder")}
        </div>
        { this.props.reminders.map((reminder) =>
          <ReminderCheckbox
            key={reminder.user_id}
            details={reminder}
            onCheck={this.props.onReminderCheck}
            maskMobile={this.props.maskMobile}
          />
          )
        }
        { this.props.others.map((other) =>
          <OtherCheckbox
            key={other.other_id}
            details={other}
            onCheck={this.props.onOtherCheck}
            mobileInput={this.props.mobileInput}
            removeOther={this.props.removeOther}
          />
          )
        }
        <div className="row">
          <a className="btn btn-info" onClick={this.props.addOther}>{I18n.t("exhibitor.add_another_mobile_alert")}</a>
        </div>
        <br/>
        <div className="row">
          <a className="btn btn-primary" href='/rts'>Back</a>
          &nbsp;
          <a className="btn btn-success" onClick={this.props.submitAction}>Submit</a>
        </div>
      </div>
    );
  }
}
